export enum Education {
  InvalidEducation = 0,
  Doctor = 1,
  Master = 2,
  Bachelor = 3,
  JoniorCollege = 4,
  HighSchool = 5,
  Other = 6,
}

export enum EduVerifyStatus {
  InvalidStatus = 0,
  Verifying = 1,
  Refused = 2,
  Verified = 3,
  Expried = 4,
}

export interface EduVerify {
  id: number
  userID: number
  realName: string
  schoolName: string
  education: number
  enrollTime: {
    seconds: number
  }
  graduationTime: {
    seconds: number
  }
  createTime: {
    seconds: number
  }
  verifyType: number
  status: number
  refuseReason: string
  idCardFilename: string
  email: string
  role: number
}
